(() => {
  if (window.DecoSavedLists) return;
  const root = document.querySelector('deco-saved-lists');
  if (!root) return;
  const config = JSON.parse(root.dataset.config), t = config.labels;
  const dialog = root.querySelector('dialog'), body = root.querySelector('[data-lists-body]'), status = root.querySelector('[data-lists-status]');
  const digit = value => typeof value === 'string' && /^\d+$/.test(value);
  const handleOK = value => typeof value === 'string' && /^[a-z0-9][a-z0-9-]{0,254}$/.test(value);
  const identity = item => item.productId + ':' + (item.variantId || 'product');
  const validItem = item => item && digit(item.productId) && handleOK(item.handle) && (item.variantId === null || digit(item.variantId)) && item.quantity === 1 && typeof item.title === 'string' && item.title.length <= 500;
  const emptyState = () => ({version: 1, revision: 0, lists: [{id: 'default', name: t.default_list, items: []}]});
  const readState = () => {
    const raw = localStorage.getItem(config.storageKey);
    if (raw === null) return emptyState();
    const data = JSON.parse(raw);
    if (data?.version !== 1 || !Number.isSafeInteger(data.revision) || data.revision < 0 || !Array.isArray(data.lists) || data.lists.length > 50) throw Error('storage');
    const ids = new Set();
    for (const list of data.lists) {
      if (!list || typeof list.id !== 'string' || !/^[a-zA-Z0-9-]{1,80}$/.test(list.id) || ids.has(list.id) || typeof list.name !== 'string' || !list.name.trim() || list.name.length > 60 || !Array.isArray(list.items) || list.items.length > 500 || !list.items.every(validItem) || new Set(list.items.map(identity)).size !== list.items.length) throw Error('storage');
      ids.add(list.id);
    }
    return data;
  };
  let state, storageError = false, view = 'overview', listId = 'default', pendingItem = null, opener = null, page = 0, generation = 0, busy = false, selectionRequest = 0;
  const uncertain = new Set(), cartPending = new Set();
  let cartLockFailed = false;
  const cartLockReady = () => !cartLockFailed && !!navigator.locks?.request && typeof config.cartLock === 'string' && config.cartLock.startsWith('deco-rebuild:cart-write:v1:');
  const say = (message, error = false) => { status.textContent = message; status.dataset.error = String(error); };
  const el = (tag, text, attrs = {}) => {
    const node = document.createElement(tag);
    if (text !== null) node.textContent = text;
    Object.entries(attrs).forEach(([key, value]) => node.setAttribute(key, value));
    return node;
  };
  const button = (label, fn, attrs = {}) => { const node = el('button', label, {type: 'button', ...attrs}); node.addEventListener('click', fn); return node; };
  const productURL = item => { const url = new URL(config.root + 'products/' + encodeURIComponent(item.handle), location.origin); if (item.variantId) url.searchParams.set('variant', item.variantId); return url; };
  const cartURL = () => new URL(config.cartUrl, location.origin).href;
  const read = () => { try { state = readState(); storageError = false; } catch { state = null; storageError = true; } };
  const updateCount = () => {
    const count = state ? new Set(state.lists.flatMap(list => list.items.map(identity))).size : null;
    document.querySelectorAll('[data-deco-lists-count]').forEach(node => { node.textContent = count === null ? '–' : String(count); });
    window.dispatchEvent(new CustomEvent('deco:saved-lists:change', {detail: {count, persistent: !storageError}}));
  };
  const write = async (change, success, message = t.saved) => {
    if (busy) return;
    if (!navigator.locks?.request) { say(t.storage_unsupported, true); return; }
    busy = true; body.setAttribute('aria-busy', 'true');
    try {
      await navigator.locks.request(config.storageKey, async () => {
        let next; try { next = readState(); } catch { next = emptyState(); }
        change(next);
        next.revision += 1;
        const serialized = JSON.stringify(next);
        localStorage.setItem(config.storageKey, serialized);
        if (localStorage.getItem(config.storageKey) !== serialized) throw Error('storage');
        state = next; storageError = false;
      });
      success?.(); updateCount(); render(); say(message);
    } catch (error) { say(error.message === 'name' ? t.invalid_name : t.storage_error, true); }
    finally { busy = false; body.removeAttribute('aria-busy'); }
  };
  const addItem = (list, item) => {
    if (!validItem(item)) throw Error('storage');
    if (!list.items.some(other => identity(other) === identity(item))) {
      if (list.items.length >= 500) throw Error('storage');
      list.items.push({...item, addedAt: Date.now()});
    }
  };
  const nameForm = (rename = false) => {
    const form = el('form', null, {class: 'deco-saved-lists__name-form'}), id = 'DecoListName';
    form.append(el('label', t.list_name, {for: id}));
    const input = el('input', null, {id, name: 'list_name', type: 'text', maxlength: '60', required: '', autocomplete: 'off'});
    if (rename) input.value = state.lists.find(list => list.id === listId)?.name || '';
    form.append(input);
    const submit = el('button', rename ? t.rename_submit : pendingItem ? t.create_save : t.create, {type: 'submit'}); form.append(submit);
    form.addEventListener('submit', event => {
      event.preventDefault(); const name = input.value.normalize('NFC').trim();
      if (!name || name.length > 60) { say(t.invalid_name, true); return; }
      const item = pendingItem, target = listId, newId = crypto.randomUUID();
      write(next => {
        if (rename) { const list = next.lists.find(list => list.id === target); if (!list) throw Error('storage'); list.name = name; }
        else { if (next.lists.length >= 50) throw Error('storage'); const list = {id: newId, name, items: []}; if (item) addItem(list, item); next.lists.push(list); }
      }, () => { listId = rename ? target : newId; pendingItem = null; view = 'detail'; page = 0; }, rename ? t.renamed : item ? t.saved : t.created);
    });
    return form;
  };
  const open = trigger => {
    opener = trigger || document.activeElement; read(); updateCount(); view = 'overview'; pendingItem = null; page = 0; say(''); render();
    if (!dialog.open) dialog.showModal(); root.querySelector('[data-lists-close]').focus();
  };
  const openSave = (item, trigger) => {
    if (!validItem(item)) { open(trigger); say(t.invalid_selection, true); return; }
    open(trigger); pendingItem = {...item}; view = 'save'; render(); body.querySelector('select, input, button')?.focus();
  };
  const fetchJSON = async (url, options = {}) => {
    const abort = new AbortController(), timer = setTimeout(() => abort.abort(), 12000);
    try {
      const response = await fetch(url, {credentials: 'same-origin', cache: 'no-store', ...options, signal: abort.signal});
      let data; try { data = await response.json(); } catch { const error = Error('response'); error.status = response.status; throw error; }
      if (!response.ok) { const error = Error(typeof data.description === 'string' ? data.description : 'request'); error.status = response.status; throw error; }
      return data;
    } finally { clearTimeout(timer); }
  };
  const loadItem = async item => {
    const url = productURL(item); url.searchParams.set('view', 'rebuild-saved-item');
    const preview = new URL(location.href).searchParams.get('preview_theme_id');
    if (preview && /^\d+$/.test(preview)) url.searchParams.set('preview_theme_id', preview);
    else if (window.Shopify?.theme?.role === 'unpublished' && digit(config.themeId)) url.searchParams.set('preview_theme_id', config.themeId);
    const data = await fetchJSON(url.href);
    if (data?.schema !== 'deco-saved-item-v1' || data.product_id !== item.productId || data.handle !== item.handle || typeof data.title !== 'string' || typeof data.price_text !== 'string' || !Number.isFinite(data.price) || typeof data.currency !== 'string') throw Error('response');
    data.exact = item.variantId ? data.variant_id === item.variantId : data.has_only_default_variant === true && digit(data.variant_id);
    return data;
  };
  const cartQty = (cart, variantId) => cart.items.filter(item => String(item.variant_id || item.id) === variantId).reduce((sum, item) => sum + item.quantity, 0);
  const refreshCart = cart => { if (!Array.isArray(cart.items) || !Number.isInteger(cart.item_count)) throw Error('cart'); window.dispatchEvent(new CustomEvent('cartcount:update', {detail: cart})); };
  const buy = async (item, displayed, card) => {
    const key = identity(item); if (cartPending.has(key) || uncertain.has(key) || config.directAddEnabled !== true || !cartLockReady()) return;
    cartPending.add(key); card.querySelectorAll('button').forEach(node => { node.disabled = true; });
    try {
      await navigator.locks.request(config.cartLock, {mode: 'exclusive'}, async () => {
        let posted = false, accepted = false;
        try {
          const fresh = await loadItem(item);
          if (!fresh.exact || fresh.direct_add !== true || fresh.available !== true || item.quantity !== 1) { paintCard(card, item, fresh); say(t.unavailable, true); return; }
          if (fresh.price !== displayed.price || fresh.currency !== displayed.currency) { paintCard(card, item, fresh); say(t.price_changed, true); return; }
          const before = await fetchJSON(config.root + 'cart.js'); if (!Array.isArray(before.items)) throw Error('cart');
          const quantityBefore = cartQty(before, fresh.variant_id);
          posted = true;
          const added = await fetchJSON(config.root + 'cart/add.js', {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify({items: [{id: fresh.variant_id, quantity: 1}]})});
          if (!Array.isArray(added?.items) || !added.items.some(line => String(line.variant_id || line.id) === fresh.variant_id)) throw Error('unconfirmed');
          accepted = true;
          try { refreshCart(await fetchJSON(config.root + 'cart.js')); } catch { }
          say(t.added); window.dispatchEvent(new CustomEvent('deco:saved-lists:cart-added', {detail: {productId: item.productId, variantId: fresh.variant_id, quantity: 1, quantityBefore}}));
        } catch (error) {
          if (posted && !accepted && error.status !== 422 && error.status !== 400) {
            uncertain.add(key); try { refreshCart(await fetchJSON(config.root + 'cart.js')); } catch { }
            say(t.cart_uncertain, true);
          } else say(error.status === 422 && error.message !== 'request' ? error.message : t.cart_error, true);
        }
      });
    } catch {
      cartLockFailed = true; paintCard(card, item, displayed); say(t.cart_error, true);
    } finally {
      cartPending.delete(key); card.querySelectorAll('button').forEach(node => { node.disabled = uncertain.has(key) && node.dataset.buy === 'true'; });
    }
  };
  const paintCard = (card, item, data = null, failed = false) => {
    const restoreFocus = dialog.open && card.contains(document.activeElement);
    try {
    card.replaceChildren();
    const href = productURL(item).href;
    if (data?.image) {
      try { const imageURL = new URL(data.image, location.origin); if (['https:', 'http:'].includes(imageURL.protocol)) card.append(el('img', null, {src: imageURL.href, alt: '', loading: 'lazy', width: '180', height: '180'})); } catch { }
    }
    card.append(el('a', data?.title || item.title || item.handle, {href, class: 'deco-saved-lists__product-title'}));
    if (data?.variant_title && !data.has_only_default_variant && data.exact) card.append(el('p', data.variant_title));
    if (data && data.exact) card.append(el('p', data.price_text + ' ' + data.currency, {class: 'deco-saved-lists__price'}));
    const actions = el('div', null, {class: 'deco-saved-lists__actions'});
    const canBuy = config.directAddEnabled === true && cartLockReady() && data?.exact && data.available === true && data.direct_add === true;
    if (canBuy) {
      const add = button(t.add_to_cart, () => buy(item, data, card), {'data-buy': 'true'}); add.disabled = uncertain.has(identity(item)) || cartPending.has(identity(item)); actions.append(add);
    } else actions.append(el('a', data && !data.has_only_default_variant ? t.choose_options : t.view_product, {href}));
    if (data && (!data.exact || !data.available)) card.append(el('p', t.unavailable));
    if (failed) {
      card.append(el('p', t.load_error));
      actions.append(button(t.retry, async () => {
        const token = generation; card.setAttribute('aria-busy', 'true');
        try { const current = await loadItem(item); if (card.isConnected && token === generation) paintCard(card, item, current); }
        catch { if (card.isConnected && token === generation) paintCard(card, item, null, true); }
        finally { card.removeAttribute('aria-busy'); }
      }));
    } else if (!data) card.append(el('p', t.loading));
    actions.append(button(t.remove, () => { const target = listId; write(next => { const list = next.lists.find(list => list.id === target); if (!list) throw Error('storage'); list.items = list.items.filter(other => identity(other) !== identity(item)); }, null, t.removed); }));
    card.append(actions);
    } finally {
      if (restoreFocus && dialog.open && card.isConnected) card.querySelector('.deco-saved-lists__product-title')?.focus();
    }
  };
  const hydrate = async (cards, token) => {
    let position = 0;
    await Promise.all(Array.from({length: Math.min(4, cards.length)}, async () => {
      while (position < cards.length && token === generation) {
        const {card, item} = cards[position++];
        try { const data = await loadItem(item); if (card.isConnected && token === generation) paintCard(card, item, data); }
        catch { if (card.isConnected && token === generation) paintCard(card, item, null, true); }
      }
    }));
  };
  const render = () => {
    const restoreFocus = dialog.open && body.contains(document.activeElement);
    try {
    const token = ++generation; body.replaceChildren();
    if (storageError || !state) { body.append(el('p', t.storage_error)); return; }
    if (view !== 'overview') body.append(button(t.back, () => { view = 'overview'; pendingItem = null; page = 0; say(''); render(); }));
    if (view === 'save') {
      body.append(el('h3', pendingItem.title || pendingItem.handle));
      const select = el('select', null, {id: 'DecoListChoice'}); state.lists.forEach(list => select.append(el('option', list.name, {value: list.id})));
      body.append(el('label', t.select_list, {for: 'DecoListChoice'}), select);
      body.append(button(t.save, () => { const target = select.value, item = {...pendingItem}; write(next => { const list = next.lists.find(list => list.id === target); if (!list) throw Error('storage'); addItem(list, item); }, () => { pendingItem = null; listId = target; page = 0; view = 'detail'; }); }));
      body.append(el('h3', t.new_list), nameForm()); return;
    }
    if (view === 'rename') { body.append(nameForm(true)); body.querySelector('input')?.focus(); return; }
    if (view === 'detail') {
      const list = state.lists.find(list => list.id === listId); if (!list) { view = 'overview'; render(); return; }
      body.append(el('h3', list.name));
      body.append(button(t.rename, () => { view = 'rename'; render(); }));
      body.append(el('p', t.items_count.replace('__COUNT__', String(list.items.length))));
      if (!list.items.length) { body.append(el('p', t.empty)); return; }
      page = Math.min(page, Math.floor((list.items.length - 1) / 12));
      const grid = el('ul', null, {class: 'deco-saved-lists__grid'}), cards = [];
      list.items.slice(page * 12, page * 12 + 12).forEach(item => { const card = el('li', null, {class: 'deco-saved-lists__card'}); grid.append(card); paintCard(card, item); cards.push({card, item}); });
      body.append(grid);
      const pagination = el('div', null, {class: 'deco-saved-lists__actions'});
      if (page) pagination.append(button(t.previous, () => { page -= 1; render(); }));
      if ((page + 1) * 12 < list.items.length) pagination.append(button(t.next, () => { page += 1; render(); }));
      body.append(pagination, el('a', t.view_cart, {href: cartURL(), class: 'deco-saved-lists__cart-link'})); hydrate(cards, token); return;
    }
    const lists = el('ul', null, {class: 'deco-saved-lists__overview'});
    state.lists.forEach(list => {
      const card = el('li', null); card.append(button(list.name, () => { listId = list.id; page = 0; view = 'detail'; say(''); render(); })); card.append(el('p', t.items_count.replace('__COUNT__', String(list.items.length)))); lists.append(card);
    });
    body.append(lists, el('h3', t.new_list), nameForm(), button(t.continue_shopping, () => dialog.close()));
    } finally {
      if (restoreFocus && dialog.open && !body.contains(document.activeElement)) {
        const target = (view === 'detail' ? body.querySelector('h3') : body.querySelector('button, input, select, a')) || root.querySelector('[data-lists-close]');
        if (target?.tagName === 'H3') target.tabIndex = -1;
        target?.focus();
      }
    }
  };
  const saveFromButton = async trigger => {
    const ticket = ++selectionRequest;
    const item = {productId: trigger.dataset.productId, handle: trigger.dataset.decoProductHandle, variantId: trigger.dataset.defaultVariant || null, quantity: 1, title: (trigger.dataset.productTitle || '').slice(0, 500)};
    trigger.setAttribute('aria-busy', 'true');
    try {
      if (trigger.dataset.saveContext === 'product') {
        const selection = trigger.closest('.product--outer')?.querySelector('[data-variant-selection]');
        if (selection) {
          if (typeof selection.getVariant !== 'function') throw Error('selection');
          const current = selection.getAttribute('variant'), variant = await selection.getVariant();
          if (selection.getAttribute('variant') !== current || (variant && String(variant.id) !== current)) throw Error('changed');
          if (!variant && /^\d+$/.test(current || '')) throw Error('selection');
          item.variantId = variant ? String(variant.id) : null;
        } else if (!item.variantId) throw Error('selection');
      }
      if (ticket === selectionRequest) openSave(item, trigger);
    } catch (error) { if (ticket === selectionRequest) { open(trigger); say(error.message === 'changed' ? t.selection_changed : t.invalid_selection, true); } }
    finally { trigger.removeAttribute('aria-busy'); }
  };
  root.querySelector('[data-lists-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('close', () => { generation += 1; if (opener?.isConnected) opener.focus(); });
  document.addEventListener('click', event => {
    const save = event.target.closest('[data-deco-save]'); if (save) { event.preventDefault(); saveFromButton(save); return; }
    const openButton = event.target.closest('[data-deco-lists-open]'); if (openButton) { event.preventDefault(); open(openButton); }
  });
  const reveal = scope => {
    if (scope.matches?.('[data-deco-save], [data-deco-lists-open]')) scope.hidden = false;
    scope.querySelectorAll?.('[data-deco-save], [data-deco-lists-open]').forEach(node => { node.hidden = false; });
  };
  new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(node => { if (node.nodeType === 1) reveal(node); }))).observe(document.body, {childList: true, subtree: true});
  window.addEventListener('storage', event => {
    if (event.key !== config.storageKey) return;
    read(); updateCount();
    const editing = body.contains(document.activeElement) && ['INPUT', 'SELECT'].includes(document.activeElement.tagName);
    if (dialog.open && view !== 'rename' && view !== 'save' && !editing) render();
  });
  read(); updateCount(); reveal(document); root.dataset.ready = 'true';
  window.DecoSavedLists = Object.freeze({open, openSave});
})();
